var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExport = function SvgIconExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M8.063 5.438 12 1.5m0 0 3.938 3.938M12 1.5V12m4.5-2.625h2.25a.75.75 0 0 1 .75.75V19.5a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75v-9.375a.75.75 0 0 1 .75-.75H7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.205.705c.439-.44 1.151-.44 1.59 0l3.938 3.937a1.125 1.125 0 0 1-1.591 1.591l-2.017-2.017V12a1.125 1.125 0 0 1-2.25 0V4.216L8.858 6.233a1.125 1.125 0 0 1-1.591-1.591zM5.624 10.5H7.5a1.125 1.125 0 0 0 0-2.25H5.25a1.875 1.875 0 0 0-1.875 1.875V19.5a1.875 1.875 0 0 0 1.875 1.875h13.5a1.875 1.875 0 0 0 1.875-1.875v-9.375A1.875 1.875 0 0 0 18.75 8.25H16.5a1.125 1.125 0 0 0 0 2.25h1.875v8.625H5.625z",
    clipRule: "evenodd"
  })));
};
export default SvgIconExport;